module.exports = __webpack_public_path__ + "img/1567015959.83cb8967.jpg";